import {
  OnlyFilterActionDisplayStrategy,
  GeneralChipComponentCreator,
  DataTransformer,
  TableFieldDescription,
  DataMapper,
  NullClickStrategy,
  DateTimeComponentCreator,
  DateTimeDisplayCreator
} from  '../../components/BPMTable/TableMapperCreator'
import * as f from '../../components/BPMTable/BPMInputs'
import TableCreatorCreator from '../../components/BPMTable/TableCreatorFactory/TableCreatorCreator';
import tableCreatorCreatorFactoryCreator from '../../components/BPMTable/TableCreatorFactory/TableCreatorCreatorFactoryCreator';
import {DirectTableQueryBuilder} from "../../components/BPMTable/TableQueryBuilder/DirectTableQueryBuilder";
import {QueryVariable} from "../../components/BPMTable/TableQueryBuilder/AbstractVariableStrategy";


const HistoryTableCreatorQueries = {tableQueryBuilder: new DirectTableQueryBuilder('allModelChange')}


class HistoryTableCreator extends TableCreatorCreator {

    static getId = () => {
        return "HistoryTableCreator"
    }

    getTableCreator = (tableName) => {
        const tableCreator =  this.createTableCreator(this.constructor.getId(), tableName, HistoryTableCreatorQueries, new NullClickStrategy(), new OnlyFilterActionDisplayStrategy());
        tableCreator.setInitialSortField('changedAt', 'desc')
        tableCreator.setVariables([
          new QueryVariable('objectId', 'String!'),
          new QueryVariable('objectType', 'String!')
        ]);
        tableCreator.addDescriptions ([
          new TableFieldDescription(
            'source',
            new DataMapper("group.source"),
            new f.FilterDescription(new f.TextFilter("source")),
            {label: 'Source'}
          ),
          new TableFieldDescription(
            'action',
            new DataMapper("action"),
            new f.FilterDescription(new f.TextFilter("action")),
            {label: 'Action'}
          ),
          new TableFieldDescription(
              'changedBy',
              new DataMapper("group.changedBy.enterpriseId"),
              new f.FilterDescription(new f.TextFilter("changedBy")),
              {label: 'Changed By'}
          ),
          new TableFieldDescription(
            'changedAt',
            new DataMapper("group.changedAt"),
            new f.FilterDescription(new f.DateFilter("changedAt")),
            {
              label: 'Changed At',
              componentCreator: new DateTimeComponentCreator(),
              excelDisplay: new DateTimeDisplayCreator()
            }
          ),
          new TableFieldDescription(
            'fields',
            new DataMapper("fields", 'fields.fieldName', 'fields.valuesFrom', 'fields.valuesTo'),
            new f.FilterDescription(new f.TextFilter("fieldName")),
            {
              label: 'Changes',
              componentCreator : new GeneralChipComponentCreator(["fieldName"],["fieldName","valuesFrom","valuesTo"], null, false),
              transform: new DataTransformer(({fields})=> Object(fields))
            }
          ),
        ])

        return tableCreator;
    }
}

tableCreatorCreatorFactoryCreator.addTableCreatorCreator(HistoryTableCreator)

export default HistoryTableCreator;
